// Import and register all controllers
import { application } from "./application"

// Import controllers
import FrameRefreshController from "./frame_refresh_controller"
import NudgeModalController from "./nudge_modal_controller"
import PolarityToggleController from "./polarity_toggle_controller"
import ScaleFormController from "./scale_form_controller"
import SortableController from "./sortable_controller"

// Register controllers
application.register("frame-refresh", FrameRefreshController)
application.register("nudge-modal", NudgeModalController)
application.register("polarity-toggle", PolarityToggleController)
application.register("scale-form", ScaleFormController)
application.register("sortable", SortableController)
